import { render, staticRenderFns } from "./category.vue?vue&type=template&id=6dd567f2"
import script from "./category.vue?vue&type=script&lang=js"
export * from "./category.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../makeup-web/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports